import { useContext, useEffect, useState } from 'react';
import '../App.css';
import { FarmsDatatable } from '../components/datatables/farmsDatatable';
import ArchiveFarmDialog from '../components/dialogs/archiveFarmDialog';
import CreateNewfarmDialog from '../components/dialogs/createNewFarmDialog';
import { AuthContext } from '../context/AuthContext';
import api from '../lib/api';

function Farms() {
    const [farms, setfarms] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { auth } = useContext(AuthContext);

    const fetchfarms = () => {
        setIsLoading(true);
        api.get('https://skhrf-api.cmdigital.se/v1/farms/')
            .then(response => {
                let farms = response.data;

                setfarms(farms);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching farms:', error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchfarms();
    }, []);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                    <h1 className='font-medium text-2xl'>Gårdar</h1>
                    <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 pt-3'>
                        {(auth.user?.superadmin || auth?.user?.bunnyadmin) && (
                            <>
                                <CreateNewfarmDialog fetchfarms={fetchfarms} />
                                <ArchiveFarmDialog farms={farms} fetchfarms={fetchfarms} isFarmsLoading={isLoading} />
                            </>
                        )}
                    </div>
                </div>
                <FarmsDatatable farms={farms} isLoading={isLoading} />
            </div>
        </div>
    );
}

export default Farms;
